import React from "react";
import { Link } from "basis";
import styled, { css } from "styled-components";
import { COLOR } from "./theme";

const StyledLink = styled.div`
  cursor: pointer;

  ${(props) =>
    props.noMaxHeight &&
    css`
      && {
        max-height: none;
      }
    `}

  ${(props) =>
    props.inline &&
    css`
      && {
        display: inline;
      }
    `}

  ${(props) =>
    props.smallFont &&
    css`
      && a span {
        color: ${COLOR.DARK_GREY};
        font-size: 14px;
        border-bottom-color: ${COLOR.DARK_GREY};
      }
    `}

  ${(props) =>
    props.fontColor &&
    css`
      && a span {
        color: ${props.fontColor};
      }
      && a span:hover {
        color: ${props.fontColor};
        background-color: transparent;
      }
    `}

  ${(props) =>
    props.font14 &&
    css`
      && a span {
        font-size: 14px;
      }
    `}
  ${(props) =>
    props.borderBottomColor &&
    css`
      && a span {
        border-bottom-color: ${props.borderBottomColor};
      }
    `}

   ${(props) =>
     props.fontWeight &&
     css`
       && a span {
         font-weight: ${props.fontWeight};
       }
     `}

  ${(props) =>
    props.newFont &&
    css`
      && a span {
        font-weight: 600;
        color: ${COLOR.LATITUDE_BLUE_INDIGO};
        font-family: "LatitudeSans", san-serif;
        border-bottom-color: ${COLOR.LATITUDE_BLUE_INDIGO};
        && a span:hover {
          color: ${COLOR.LATITUDE_BLUE_INDIGO};
          background-color: transparent;
        }
      }
    `}
  
`;

export default ({
  noMaxHeight,
  children,
  smallFont,
  font14,
  inline,
  fontColor,
  borderBottomColor,
  fontWeight,
  newFont,
  ...props
}) => (
  <StyledLink
    inline={inline}
    noMaxHeight={noMaxHeight}
    smallFont={smallFont}
    font14={font14}
    fontColor={fontColor}
    borderBottomColor={borderBottomColor}
    fontWeight={fontWeight}
    newFont={newFont}
  >
    <Link href="" {...props}>
      {children}
    </Link>
  </StyledLink>
);
